import { render } from "./AllOrders.vue?vue&type=template&id=da180194&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"

import "./AllOrders.vue?vue&type=style&index=0&id=da180194&scoped=true&lang=css"
import "./AllOrders.vue?vue&type=style&index=1&id=da180194&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da180194"]])

export default __exports__